import { Drug, RequestBatchResult } from "domain/entities/drug";
import { DrugRepository } from "domain/repositories";

export default class CreateBatchUseCase {
    private drugRepository: DrugRepository;
    
    public constructor(drugRepository: DrugRepository) {
        this.drugRepository = drugRepository
    }

    public async createDrugBatch(drug: Drug[], token: Promise<[string | null, string | null]>): Promise<[RequestBatchResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugRepository.createDrugBatch(drug, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}